(function () {
    'use strict';

    a3_cabin_reports.controller('FlightInfoCtrl', FlightInfoCtrl);
    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name FlightInfoCtrl
     * @description 
     *   Shows the flight informations
     * @ngInject
     */
    function FlightInfoCtrl($scope, FlightFactory, MessageFactory, $routeParams, AircaftPositionsFactory, CrewCallFactory, PreviousDutyFactory,
        $location, $uibModal, PaxInfoFactory, CampaignFactory, UserFactory, barOptions, $anchorScroll, enableFaceMasks,
        FlightCheckInsFactory, CrewRouteFactory, defaultCalendarDate, mealCriteriaIsEnabled, LotteryFactory) {

        var flightId = $routeParams.flightId;
        var flight = FlightFactory.getFlightFromTotalFlights(flightId);
        var crewPhoneNumbers = CrewCallFactory.getFlightCrewCallsFromStorage(flightId);
        var previousDuties = PreviousDutyFactory.getFlightPreviousDutiesFromStorage(flightId);

        $scope.user = UserFactory.getUser();
        $scope.flightId = flightId;
        $scope.shownSideMenu = false;
        $scope.sideMenuItems = [];
        $scope.showSidePanel = showSidePanel;
        $scope.hideSidePanel = hideSidePanel;
        $scope.goToPanel = goToPanel;
        $scope.gotoMealLibrary = gotoMealLibrary;   
        $scope.mealCriteriaIsEnabled = mealCriteriaIsEnabled;

        $scope.isMobile = (window.innerWidth <= 800 && window.innerHeight <= 740);

        $scope.campaigns = CampaignFactory.getCampaignsByFlightId(+flightId);

        // function detectMobile() {
        //     $scope.isMobile =(window.innerWidth <= 800 && window.innerHeight <= 740); 
        //     console.log($scope.isMobile);
        //     return $scope.isMobile;		
        // }	

        function hideSidePanel() {
            $scope.shownSideMenu = false;
        }

        function goToPanel(id) {
            $location.hash(id);
            $anchorScroll();
            hideSidePanel();
        };

        function gotoMealLibrary(cabinClass) {
            $location.path('/mealLibrary/'+ $scope.flightId + '/' + cabinClass);
        }

        function showSidePanel() {
            $scope.sideMenuItems = [];
            $('.panel-heading .title').each(function () {
                var menuItem = {};
                menuItem.id = $(this).attr("id");
                menuItem.title = $(this).html();
                menuItem.icon = $(this).data('icon');
                $scope.sideMenuItems.push(menuItem);
            })
            $scope.shownSideMenu = true;
        }


        if (!flight) {
            // go to dashboard if no flight
            $location.path("/");
        } else {

            applyPhoneNumber();
            applyPreviousDuty();
            applyCrewCheckInStatus();
            PaxInfoFactory.setMaskPaxInfoInRoute(flight);

            // ── Lottery ──────────────────────────────────────────────────────────
            $scope.applicableLotteries = LotteryFactory.getApplicableLotteries(flight);
            var submittedLotteries = LotteryFactory.getSubmittedLotteriesFromStorage() || [];
            $scope.isLotterySubmitted = function (lotteryId) {
                var key = String(lotteryId) + '_' + String(flightId);
                return submittedLotteries.some(function (s) { return String(s.Id) === key; })
                    || LotteryFactory.hasPendingResult(key);
            };
            $scope.openLottery = function (lotteryId) {
                $location.path('/lottery/' + flightId + '/' + lotteryId);
            };
          
            // ─────────────────────────────────────────────────────────────────────

            $scope.flightCrewPreviousDuty = flight.crew.filter(x => x.PreviousDuty && x.PreviousDuty.isDifferent && (x.position == "CP" || x.position == "FO") && !x.isDHC).length;
            $scope.cabinCrewPreviousDuty = flight.crew.filter(x => x.PreviousDuty && x.PreviousDuty.isDifferent && (x.position == "SA" || x.position == "FA") && !x.isDHC).length;
            $scope.dhcCrewPreviousDuty = flight.crew.filter(x => x.PreviousDuty && x.PreviousDuty.isDifferent && x.isDHC).length;
            $scope.hasPreviousDuties = $scope.flightCrewPreviousDuty + $scope.cabinCrewPreviousDuty + $scope.dhcCrewPreviousDuty;

            // Check if the flight is today or in the past for displaying departure panel
            $scope.isTodayOrPast = function (scheduledDeparture) {
                if (!scheduledDeparture) return false;

                var depDate = moment(scheduledDeparture).startOf('day');
                if (defaultCalendarDate) {
                    depDate = moment(defaultCalendarDate).startOf('day');
                }
                const now = moment().startOf('day');

                return depDate.isSameOrBefore(now);
            };

            //Update scopes for the CrewRoutePanel in Flight-page
            $scope.crewRouteInfoPanel = CrewRouteFactory.getCrewRouteInfoPanel(flight);

            $scope.saEligibility = flight.LineStatus != 'na';
            //  (flight.Position == "SA" || (flight.Position != "SA" && !flight.getSeniorAttendantsCount() && flight.Fleet.Id==2 ));

            //Manage Face Mask Panel visibility - Show only to SA or OA flights with no SA
            $scope.enableFaceMasks = enableFaceMasks &&
                flight &&
                $scope.saEligibility;

            //todo :: epap replace with flightId 1312896

            var aircaftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId(flight.FlightId);

            $scope.state = 'flight'
            $scope.flight = flight;
            $scope.aircaftPositions = aircaftPositions;
            $scope.IsProvisional = true;

            $scope.flightZones = RenderFlightZones(flight.Zones);
            //Initialize Zones
            function onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
            }
            function RenderFlightZones(zones) {

                if (!zones)
                    return;

                var flightZones = [];

                var zoneTitles = zones.map(function (item) {
                    return item.Title;
                });
                var uniqueZones = zoneTitles.filter(onlyUnique);
                // //or
                // var uniqueZones2 = Array.from(new Set(zoneTitles));

                uniqueZones.forEach(function (element) {

                    var getZoneCounter = zoneTitles.filter(function (item) {
                        return item == element;
                    });
                    if (getZoneCounter.length > 1) {
                        flightZones.push({ Title: element.Title, Class: null })
                    } else {
                        var zone = zones.filter(function (item) {
                            return item.Title == element;
                        });
                        flightZones.push(zone[0]);
                    }
                });
                return flightZones;
            }

            //Initialize Messages
            $scope.messages = MessageFactory.getMessagesFromIds(flight.messages);
            var messages = $scope.messages;
            $scope.openMessage = openMessage;

            //Initialize scope variables
            $scope.isEnabled = false;
            $scope.isPanelOpen = true;
            $scope.showConnFlights = true;

            //Charts
            $scope.crewChart = generateCrewChart(flight);
            $scope.generateMealChart = generateMealChart;

            //1226541
            PaxInfoFactory.getPaxInfoFromStorage(flight.FlightId, function (paxInfo) {
                $scope.paxInfo = paxInfo;

                if (paxInfo) {

                    $scope.cStat = (paxInfo.PaxTotalC / paxInfo.ConfigurationC) * 100;
                    $scope.yStat = (paxInfo.PaxTotalY / paxInfo.ConfigurationY) * 100;

                    $scope.mealsChart = generateMealChart(paxInfo);

                    var listSentTimestamp = new Date(paxInfo.LastRun).getTime();
                    var DepartureTimestamp = new Date(flight.ScheduledDeparture).getTime();
                    //20 minutes before takeoff
                    if (DepartureTimestamp - listSentTimestamp <= 1200000) {
                        $scope.IsProvisional = false; 
                    }
                }
            });

            var flightArrivalTime = new Date(flight.ScheduledArrival).getTime();
            $scope.flightETA = flight.ETA ? new Date(flight.ETA).getTime() : flightArrivalTime;

            //Initialize scope functionality
            $scope.isConnectedFlightClose = isConnectedFlightClose;
            $scope.TimeDifference = TimeDifference;
            $scope.openFlightConfig = openFlightConfig;
            $scope.openGates = openGates;

            //TODO : find a more angular way (EPAP)

            $scope.togglePanel = togglePanel;
            //TODO : find a more angular way (EPAP)
            $scope.toggleViewMode = toggleViewMode;


            //Initialize CSS classes
            $scope.getTextClass = getTextClass();
            $scope.getTopClass = getTopClass();
            $scope.getBottomClass = getBottomClass();
            $scope.hasIcon = hasIcon();
            $scope.getAssessmentTextClass = getAssessmentTextClass();

            //Controllers Functions

            //TODO : find a more angular way (EPAP)
            /**
             * toggle View Mode
             * @memberof FlightInfoCtrl
             * @param {string} elem
             * @param {string} className     
             */
            function toggleViewMode(elem, className) {
                $('body').find('div#' + elem + ' > div').not('.tip').hide("slow");
                $('body').find('div#' + elem + ' div.' + className).not('.tip').show("slow");
            }

            //TODO : find a more angular way (EPAP)
            /**
             * toggle Panel
             * @memberof FlightInfoCtrl
             * @param {number} panelId
             */
            function togglePanel(panelId) {
                $('#' + panelId).toggle();
                if (panelId == "info-panel")
                    $scope.isPanelOpen = !$scope.isPanelOpen;
            }



            /**
             * Open modal to see information for the selected message
             * @memberof FlightInfoCtrl
             * @param {object} message A message object
             */
            function openMessage(message) {

                var modalInstance = $uibModal.open({
                    templateUrl: 'views/Dialogs/dlgMessage.html',
                    controller: 'MessageModalCtrl',
                    size: 'lg',
                    keyboard: false,
                    backdrop: "static",
                    resolve: {
                        message: function () {
                            return message;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    if (message.ReadDt == null) {
                        MessageFactory.markReaden(message.Id);
                        message.ReadDt = new Date();
                    }
                })
            }

            /**
             * Open modal to see information for gates and connections
             * @memberof FlightInfoCtrl
             */
            function openGates() {
                var modalInstance = $uibModal.open({
                    templateUrl: 'views/Dialogs/dlgFlightGates.html',
                    controller: 'FlightGateCtrl',
                    size: 'lg',
                    resolve: {
                        flight: function () {
                            return $scope.flight;
                        }
                    }
                });
                modalInstance.result.then(function (selectedItem) {
                    $scope.gates = selectedItem;
                });
            }


            /**
             * Return the text ccs class accoriding to report status
             * @memberof FlightInfoCtrl
             * @returns {string} cssClass
             */
            function getTextClass() {
                var classname = "";
                if (flight.LineStatus === 'na')
                    classname = "text-gray";
                else if (flight.LineStatus === 'pending')
                    classname = "text-blue";
                else if (flight.LineStatus === 'pendingoverdue')
                    classname = "text-blue";
                else if (
                    (flight.LineStatus === 'draft') ||
                    (flight.LineStatus === 'draftotheruser')
                ) {
                    classname = "text-orange";
                } else if (
                    (flight.LineStatus === 'completed') ||
                    (flight.LineStatus === 'completedotheruser')
                ) {
                    classname = "text-purple";
                } else if (
                    (flight.LineStatus === 'stored') ||
                    (flight.LineStatus === 'storedotheruser') ||
                    (flight.LineStatus === 'stored+otheruser') ||
                    (flight.LineStatus === 'synched') ||
                    (flight.LineStatus === 'synchedotheruser')
                ) {
                    classname = "text-green";
                }
                return classname;
            }

            /**
             * Return the panel upper ccs class accoriding to report status
             * @memberof FlightInfoCtrl
             * @returns {string} cssClass
             */
            function getTopClass() {
                var classname = "";
                if (flight.LineStatus === 'na')
                    classname = "border-top-gray";
                else if (flight.LineStatus === 'pending')
                    classname = "border-top-blue";
                else if (flight.LineStatus === 'pendingoverdue')
                    classname = "border-top-blue";
                else if (
                    (flight.LineStatus === 'draft') ||
                    (flight.LineStatus === 'draftotheruser')
                ) {
                    classname = "border-top-orange";
                } else if (
                    (flight.LineStatus === 'completed') ||
                    (flight.LineStatus === 'completedotheruser')
                ) {
                    classname = "border-top-purple";
                } else if (
                    (flight.LineStatus === 'stored') ||
                    (flight.LineStatus === 'storedotheruser') ||
                    (flight.LineStatus === 'stored+otheruser') ||
                    (flight.LineStatus === 'synched') ||
                    (flight.LineStatus === 'synchedotheruser')
                ) {
                    classname = "border-top-green";
                }
                return classname;
            }

            /**
             * Return the panel border ccs class accoriding to report status
             * @memberof FlightInfoCtrl
             * @returns {string} cssClass
             */
            function getBottomClass() {
                var classname = "";
                if (flight.LineStatus === 'na')
                    classname = "border-bottom-gray";
                else if (flight.LineStatus === 'pending')
                    classname = "border-bottom-blue";
                else if (flight.LineStatus === 'pendingoverdue')
                    classname = "border-bottom-blue";
                else if (
                    (flight.LineStatus === 'draft') ||
                    (flight.LineStatus === 'draftotheruser')
                ) {
                    classname = "border-bottom-orange";
                } else if (
                    (flight.LineStatus === 'completed') ||
                    (flight.LineStatus === 'completedotheruser')
                ) {
                    classname = "border-bottom-purple";
                } else if (
                    (flight.LineStatus === 'stored') ||
                    (flight.LineStatus === 'storedotheruser') ||
                    (flight.LineStatus === 'stored+otheruser') ||
                    (flight.LineStatus === 'synched') ||
                    (flight.LineStatus === 'synchedotheruser')
                ) {
                    classname = "border-bottom-green";
                }
                return classname;
            }

            /**
             * If report from another user exists, show icon
             * @memberof FlightInfoCtrl
             * @returns {boolean} hasIcon
             */
            function hasIcon() {
                var hasIcon = false;
                if (
                    (flight.LineStatus === 'draftotheruser') ||
                    (flight.LineStatus === 'completedotheruser') ||
                    (flight.LineStatus === 'storedotheruser') ||
                    (flight.LineStatus === 'stored+otheruser') ||
                    (flight.LineStatus === 'synchedotheruser')
                ) {
                    hasIcon = true;
                }
                return hasIcon;
            }

           
            /**
             * Calculates if a connecting flight is departs sort time after fligths arrival 
             * @memberof FlightInfoCtrl
             * @param {string} connection Connection STD
             * @return {string} cssClass
             */
            function isConnectedFlightClose(connection) {
                if (!connection) {
                    return '';
                }

                var connFlightDate = new Date(connection.STD).getTime();

                if ($scope.flightETA > connFlightDate)
                    return '';

                if ((connFlightDate - $scope.flightETA) < connection.MCT * 60000) {
                    return 'bg-bisque';
                }

                if ((connFlightDate - $scope.flightETA) < (connection.MCT + 15) * 60000) {
                    return 'bg-cornsilk';
                }
                return '';
            }


            /**
             * Returns the time difference
             * @memberof FlightInfoCtrl
             * @param {string} time Connection STD
             * @return {string} timeDifference
             */
            function TimeDifference(time) {
                var timeString = '';
                var sign = '';
                var dayString = null;

                if (time) {
                    var connFlightDate = new Date(time);
                    var ms = connFlightDate.getTime() - $scope.flightETA; // this is a time in milliseconds
                    if (ms < 0) {
                        ms = -ms;
                        sign = "-";
                    }
                    var days = Math.floor(ms / (24 * 60 * 60 * 1000));
                    days = days < 0 ? days + 1 : days;
                    var daysms = ms % (24 * 60 * 60 * 1000);
                    var hours = Math.floor((daysms) / (60 * 60 * 1000));
                    var hoursms = ms % (60 * 60 * 1000);
                    var minutes = Math.floor((hoursms) / (60 * 1000));
                    timeString = '<strong>' + sign + (hours > 0 ? ("0" + hours).substr(-2) + ":" : '') + ("0" + minutes).substr(-2) + '\'' + '<strong>';
                    dayString = ' <span class="badge">' + days + 'd</span>';
                }

                return timeString + ((days && days != 0) ? dayString : '');
            }

            /**
             * Open Flight config modal
             * @memberof FlightInfoCtrl
             */
            function openFlightConfig() {

                var modalInstance = $uibModal.open({
                    templateUrl: 'views/Dialogs/dlgFlightConfig.html',
                    controller: 'FlightConfigCtrl',
                    size: 'md',
                    resolve: {
                        flight: function () {
                            return $scope.flight;
                        }
                    }
                });

                modalInstance.result.then(function (selectedItem) {
                    $scope.flightETA = new Date(selectedItem.ETA).getTime();
                    $scope.flight = selectedItem;
                });
            }

            /**
             * Returns the assessment Text Class
             * @memberof FlightInfoCtrl
             * @return {string} classname
             */
            function getAssessmentTextClass() {
                var classname = "";
                if (flight.assessment) {
                    if (flight.assessment.IsExist) {
                        classname = "text-green";
                    } else if (flight.assessment.Status === 'Pending')
                        classname = "text-blue";
                    else if (flight.assessment.Status === 'Draft') {
                        classname = "text-orange";
                    } else if (flight.assessment.Status === 'Completed') {
                        classname = "text-purple";
                    } else if (flight.assessment.Status === 'Stored') {
                        classname = "text-green";
                    }
                }
                return classname;
            }

            /**
             * Returns the crew Chart
             * @memberof FlightInfoCtrl
             * @param {object} flight The flight object
             * @return {object} crewChart
             */
            function generateCrewChart(flight) {

                var cp = 0;
                var fo = 0;
                var sa = 0;
                var fa = 0;

                var dhcCp = 0;
                var dhcFo = 0;
                var dhcSa = 0;
                var dhcFa = 0;

                if (flight.crew) {
                    for (var i = 0; i < flight.crew.length; i++) {
                        if (flight.crew[i].isDHC) {
                            switch (flight.crew[i].position) {
                                case "CP":
                                    dhcCp++;
                                    break;
                                case "FO":
                                    dhcFo++;
                                    break;
                                case "SA":
                                    dhcSa++;
                                    break;
                                case "FA":
                                    dhcFa++;
                                    break;
                            }
                        } else {
                            switch (flight.crew[i].position) {
                                case "CP":
                                    cp++;
                                    break;
                                case "FO":
                                    fo++;
                                    break;
                                case "SA":
                                    sa++;
                                    break;
                                case "FA":
                                    fa++;
                                    break;
                            }
                        }
                    }
                }

                var crewData = {
                    labels: ["CP", "FO", "SA", "FA"],
                    datasets: [{
                        label: "Crew",
                        fillColor: "rgba(33,150,243,0.5)",
                        strokeColor: "rgba(33,150,243,0.8)",
                        highlightFill: "rgba(33,150,243,0.75)",
                        highlightStroke: "rgba(33,150,243,1)",
                        data: [cp, fo, sa, fa]
                    }, {
                        label: "DHC",
                        fillColor: "rgba(99,181,246,0.5)",
                        strokeColor: "rgba(99,181,246,0.8)",
                        highlightFill: "rgba(99,181,246,0.75)",
                        highlightStroke: "rgba(99,181,246,1)",
                        data: [dhcCp, dhcFo, dhcSa, dhcFa]
                    }]
                };

                var crewChart = {
                    "data": crewData,
                    "options": barOptions
                };

                return crewChart;
            }

            /**
             * Returns the meal Chart
             * @memberof FlightInfoCtrl
             * @param {object} paxInfo The passenger list
             * @return {object} mealChart
             */
            function generateMealChart(paxInfo) {
                var labels = [];
                var mealCdata = [];
                var mealYdata = [];

                for (var i = 0; i < paxInfo.PassengerSummaryC.SpecialMeals.length; i++) {
                    labels.push(paxInfo.PassengerSummaryC.SpecialMeals[i].Name);
                    mealCdata.push(paxInfo.PassengerSummaryC.SpecialMeals[i].Count);
                    mealYdata.push(0);
                }

                for (var i = 0; i < paxInfo.PassengerSummaryY.SpecialMeals.length; i++) {
                    var exists = false;
                    for (var h = 0; h < labels.length; h++) {
                        if (labels[h] == paxInfo.PassengerSummaryY.SpecialMeals[i].Name) {
                            mealYdata[h] = paxInfo.PassengerSummaryY.SpecialMeals[i].Count
                            exists = true;
                            break;
                        }
                    }
                    if (!exists) {
                        labels.push(paxInfo.PassengerSummaryY.SpecialMeals[i].Name);
                        mealCdata.push(paxInfo.PassengerSummaryY.SpecialMeals[i].Count);
                        mealYdata.push(0);
                    }
                }

                var mealsData = {
                    labels: labels,
                    datasets: [{
                        label: "Business",
                        fillColor: "rgba(139,195,74,0.5)",
                        strokeColor: "rgba(139,195,74,0.8)",
                        highlightFill: "rgba(139,195,74,0.75)",
                        highlightStroke: "rgba(139,195,74,1)",
                        data: mealCdata
                    }, {
                        label: "Economy",
                        fillColor: "rgba(173,213,128,0.5)",
                        strokeColor: "rgba(173,213,128,0.8)",
                        highlightFill: "rgba(173,213,128,0.75)",
                        highlightStroke: "rgba(173,213,128,1)",
                        data: mealYdata
                    }]
                };

                var mealsChartData = {
                    "data": mealsData,
                    "options": barOptions
                };

                return mealsChartData;
            }

            /**
             * Returns the meal Chart
             * @memberof FlightInfoCtrl
             * @param {array} gates The total available gates
             * @param {array} FlightsFilters The flilters for the gates
             * @return {array} distinct_gates
             */
            function generateDistinctGates(gates, FlightsFilters) {
                var distinct_gates = [];

                for (var i = 0; i < gates.length; i++) {
                    for (var j = 0; j < FlightsFilters.length; j++) {
                        var row = gates[i].FlightNo + "," + gates[i].Codeshares.toString();
                        if (row.indexOf(FlightsFilters[j].toString()) >= 0) {
                            var distinct_gate = {
                                FlightNo: gates[i].FlightNo,
                                Gate: gates[i].DepGate,
                                Arr: gates[i].Arrival,
                                STD_lcl: gates[i].STD_lcl,
                                STD: gates[i].STD,
                                pax: null,
                                Codeshares: gates[i].Codeshares
                            }
                            distinct_gates.push(distinct_gate);
                            break;
                        }
                    }
                }

                return distinct_gates;
            }


            function applyPhoneNumber() {
                flight.crew.forEach(function (user) {
                    var phoneNumberInfo = crewPhoneNumbers.find(x => x.CrewId == user.id);
                    if (phoneNumberInfo) {
                        user.PhoneNumber = phoneNumberInfo.PhoneNumber;
                    }
                    else {
                        user.PhoneNumber = null;
                    }
                });
            }

            function applyPreviousDuty() {
                var dutyDate = moment(flight.ScheduledDeparture).startOf('day');

                flight.crew.forEach(function (user) {

                    var previousDutyInfo = previousDuties.find(x => x.CrewId == user.id);
                    if (previousDutyInfo) {
                        user.PreviousDuty = previousDutyInfo.PreviousDuty;
                    }
                    else {
                        user.PreviousDuty = null;
                    }

                    if (user.PreviousDuty && user.PreviousDuty.isFlight) {
                        var arrivalDate = user.PreviousDuty.ATA;
                        if (!arrivalDate) arrivalDate = user.PreviousDuty.ETA;
                        if (!arrivalDate) arrivalDate = user.PreviousDuty.STA;

                        user.PreviousDuty.showArrivalDate = !moment(arrivalDate).startOf('day').isSame(dutyDate);

                        var departureDate = user.PreviousDuty.ATA;
                        if (!departureDate) departureDate = user.PreviousDuty.ETA;
                        if (!departureDate) departureDate = user.PreviousDuty.STA;

                        user.PreviousDuty.showDepartureDate = !moment(departureDate).startOf('day').isSame(dutyDate);

                    }
                    if (user.PreviousDuty && !user.PreviousDuty.isFlight) {
                        user.PreviousDuty.showDate = !moment(user.PreviousDuty.GroundDutyDate).startOf('day').isSame(dutyDate);
                    }
                });
            }

            function applyCrewCheckInStatus() {
                var crewCheckInStatuses = FlightCheckInsFactory.getFlightCrewCheckInFromStorage(flightId);
                flight.crew.forEach(function (user) {
                    var statuses = crewCheckInStatuses.find(x => x.CrewId == user.id);
                    if (statuses) {
                        user.CheckIn = statuses.CheckIn;
                        user.WillBeThereAt = statuses.WillBeThereAt;
                    }
                    else {
                        user.CheckIn = null;
                        user.WillBeThereAt = null;
                    }
                });
            }
 
            $scope.staffTravellers = [];

            PaxInfoFactory.getPaxInfoFromStorage(flight.FlightId, function (paxInfo) {
                $scope.paxInfo = paxInfo;

              if (paxInfo) {
                $scope.staffTravellers = paxInfo.StaffPassengers;
              }
              
              // Show panel if there's at least one          
              $scope.hasStaffTravellers = function () {
                if($scope.staffTravellers && $scope.staffTravellers.length >0){
                    return true;
                }
                return false;
              };

              $scope.getGroupedStaff = function(type) {
                return $scope.staffTravellers
                    .filter(p => p.StaffTravellerType === type)
                    .sort((a, b) => a.Fullname.localeCompare(b.Fullname));
                };
            });

           
        }
    }
})();
